import { GameApp } from "./app/App";
import {
  gameWidth,
  gameHeight,
  colorThemes,
  setTheme,
  getCurrentTheme,
  Difficulty,
} from "./config";
import { MenuBackground } from "./app/MenuBackground";

const menu = document.querySelector("#menu") as HTMLElement;
const endgame = document.querySelector("#endgame") as HTMLElement;
const inGame = document.querySelector("#in-game") as HTMLElement;
const themeOptions = document.querySelector("#theme-options") as HTMLElement;

let background = new MenuBackground();
let currentGame: GameApp;

const applyThemeCSS = () => {
  const theme = getCurrentTheme();
  const root = document.documentElement;
  root.style.setProperty("--ui-background", theme.uiBackground);
  root.style.setProperty("--ui-text-color", theme.uiTextColor);
  root.style.setProperty("--button-background", theme.buttonBackground);
  root.style.setProperty("--button-border-color", theme.buttonBorderColor);
};

const buildThemeSwatches = () => {
  themeOptions.innerHTML = "";
  colorThemes.forEach((theme, index) => {
    const swatch = document.createElement("div");
    swatch.className = `theme-swatch${index === 0 ? " active" : ""}`;
    swatch.title = theme.name;

    const inner = document.createElement("div");
    inner.className = "theme-swatch-inner";
    inner.style.backgroundColor = theme.uiBackground;

    // Show first 6 colors as mini pie segments
    theme.circleColors.slice(0, 6).forEach((color) => {
      const span = document.createElement("span");
      span.style.backgroundColor = `#${color.toString(16).padStart(6, "0")}`;
      inner.appendChild(span);
    });

    swatch.appendChild(inner);
    swatch.addEventListener("click", () => selectTheme(index));
    themeOptions.appendChild(swatch);
  });
};

const selectTheme = async (index: number) => {
  setTheme(index);
  applyThemeCSS();

  // Update active swatch
  themeOptions.querySelectorAll(".theme-swatch").forEach((el, i) => {
    el.classList.toggle("active", i === index);
  });

  // Rebuild menu background with new colors
  background.destroy();
  background = new MenuBackground();
  await background.init(document.body, gameWidth, gameHeight);
  globalThis.__PIXI_APP__ = background.app;
};

applyThemeCSS();
buildThemeSwatches();

(async () => await background.init(document.body, gameWidth, gameHeight))();

globalThis.__PIXI_APP__ = background.app;

const loadGame = async (difficulty: Difficulty = "hard") => {
  endgame.style.display = "none";
  menu.style.display = "none";
  inGame.style.display = "block";

  if (currentGame) {
    const prevApp = currentGame;
    setTimeout(() => prevApp.app.destroy(true), 1000);
  }
  currentGame = new GameApp(
    inGame.querySelector("#score"),
    () => loadGame(difficulty),
    difficulty,
  );
  await currentGame.init(document.body, gameWidth, gameHeight);
  currentGame.beginGame();
  globalThis.__PIXI_APP__ = currentGame.app;
  background.destroy();
};
menu
  .querySelector("#play-easy")
  .addEventListener("click", () => loadGame("easy"));
menu
  .querySelector("#play-hard")
  .addEventListener("click", () => loadGame("hard"));
